module.exports = __webpack_public_path__ + "static/Design-101-Design-basics-for-non-designers-480a31d29c15a841b7b55375211ccfc3.png";